var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoaderOverlay)?_c('b-overlay',{attrs:{"no-wrap":"","fixed":"","z-index":10000,"show":true,"rounded":"sm"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('appLoader')]},proxy:true}],null,false,2771302786)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }